define('apps/admin/views/modals/archive_unarchive_modal',[
        'app',
        'njs!apps/admin/templates/includes/modals/_archive_unarchive_modal(params:tmpl=admin/main/includes/modals/_archive_unarchive_modal.html)',
    ], function(app, template) {
        'use strict';

        return Mn.ItemView.extend({

            "events": {
                "click .comet-modal__button--cancel": "closeModal",
                "click .comet-modal-overlay--backdrop": "closeModal",
            },

            "template": template,

            "initialize": function(opts){
            },

            "closeModal": function(event) {
                this.destroy();
            },

        });

});

